export default __webpack_public_path__ + "static/transitive-past-649862290ebbcfce8b65555b365cd79c.svg";